import { render } from "./Activity.vue?vue&type=template&id=05fcd5de"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"
script.render = render

export default script